"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LaTeXDisplay = undefined;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mathjax = require("@nteract/mathjax");

var _mathjax2 = _interopRequireDefault(_mathjax);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = require('react-hot-loader').enterModule;

  enterModule && enterModule(module);
})();

var LaTeXDisplay = exports.LaTeXDisplay = function LaTeXDisplay(props, context) {
  // If there's a MathJaxContext as a parent, rely on it being
  // available for the individual MathJax.Node
  if (context && context.MathJaxContext) {
    return _react2.default.createElement(
      _mathjax2.default.Node,
      null,
      props.data
    );
  }

  return _react2.default.createElement(
    _mathjax2.default.Context,
    { input: "tex" },
    _react2.default.createElement(
      _mathjax2.default.Node,
      null,
      props.data
    )
  );
};

LaTeXDisplay.MIMETYPE = "text/latex";

LaTeXDisplay.contextTypes = {
  // Opt in to updates to the MathJax object even though
  // Not explicitly used
  MathJax: _propTypes2.default.object,
  MathJaxContext: _propTypes2.default.bool
};

var _default = LaTeXDisplay;
exports.default = _default;
;

(function () {
  var reactHotLoader = require('react-hot-loader').default;

  var leaveModule = require('react-hot-loader').leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(LaTeXDisplay, "LaTeXDisplay", "src/latex.js");
  reactHotLoader.register(_default, "default", "src/latex.js");
  leaveModule(module);
})();

;


//////////////////
// WEBPACK FOOTER
// ./~/@nteract/transforms/lib/latex.js
// module id = 224
// module chunks = 186292428941015